import { render, staticRenderFns } from "./CountrySpecificChart.vue?vue&type=template&id=32b63468&scoped=true"
import script from "./CountrySpecificChart.vue?vue&type=script&lang=js"
export * from "./CountrySpecificChart.vue?vue&type=script&lang=js"
import style0 from "./CountrySpecificChart.vue?vue&type=style&index=0&id=32b63468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b63468",
  null
  
)

export default component.exports